import { Link } from "react-router-dom";
import { getFormData, getQueryString } from "../../../common";

const ComplexAreaListV2 = (props) => {
    return (<>
        <ComplexAreaSearchForm history={props.history} queryParams={props.queryParams} />
        <ComplexAreaList complexAreas={props.complexAreas} />
    </>);
};

const ComplexAreaSearchForm = ({ history, queryParams }) => {
    const onSubmit = (e) => {
        e.preventDefault();
        history.push(`?${getQueryString(getFormData(e.target))}`);
    };

    return (<>
        <form style={{ minHeight: 30 }} onSubmit={onSubmit}>
            <div className="row form-group">
                <div className="col-3 col-lg-2">
                    <input className="form-control form-control-sm" name="minLivingAreaWeight" type="number" step={100} defaultValue={queryParams.minLivingAreaWeight || 2400} />
                </div>
                <div className="col-3 col-lg-2">
                    <input className="form-control form-control-sm" name="dealLeaseGap" type="number" step={1000} defaultValue={queryParams.dealLeaseGap || 35000} />
                </div>
                <div className="col-3 col-lg-2">
                    <input className="form-control form-control-sm" name="maxAge" type="number" defaultValue={queryParams.maxAge || 25} />
                </div>
                <div className="col-3 col-lg-2 text-left">
                    <button className="btn btn-sm btn-primary" type="submit">검색</button>
                </div>
            </div>
        </form>
    </>);
};

const ComplexAreaList = ({ complexAreas }) => {
    return (<>
        <table className="table table-sm">
            <thead>
                <tr>
                    <th width="10%">앞마당</th>
                    <th width="10%">생활권</th>
                    <th width="">단지</th>
                    <th width="10%">면적</th>
                    <th width="10%">매매</th>
                    <th width="10%">전세</th>
                    <th width="10%">매전갭</th>
                    <th width="10%">최고가</th>
                </tr>
            </thead>
            <tbody>
                {complexAreas.map((v, i) => (<ComplexAreaListItem key={i} item={v} />))}
                {!complexAreas.length && <tr><td colSpan={8}>Empty</td></tr>}
            </tbody>
        </table>
    </>);
};

const ComplexAreaListItem = ({ item }) => {
    return (<tr>
        <td>{item.frontYardName}</td>
        <td>{item.livingAreaName}({item.livingAreaWeight || 0})</td>
        <td><Link to={`/realestate/complex/${item.complexId}`}>{item.complexName} {item.age}년차 {item.totalHouseholdCount.toLocaleString('ko-KR')}세대</Link></td>
        <td>{item.generalExclusiveArea}</td>
        <td>{item.dealPrice.toLocaleString('ko-KR')}</td>
        <td>{item.leasePrice.toLocaleString('ko-KR')}</td>
        <td>{item.dealLeaseGap.toLocaleString('ko-KR')}</td>
        <td>{item.topDealPrice.toLocaleString('ko-KR')}</td>
    </tr>);
};

export { ComplexAreaListV2 };
